import { theme } from "#app/theme/v1";
import { fontWeight } from "#app/theme/v1/fontWeights";
import { User } from "#modules/users/infra/User.dto";
import { formatFullName } from "#shared/helpers/formatFullName";
import { Avatar } from "#shared/view/components/Avatar";
import { Text } from "#shared/view/components/Text";

type Props = { user: User; userIndex: number };

export const UserTableContent = ({ user, userIndex }: Props) => {
  const tableElement = {
    Photo: (
      <Avatar
        radius="xl"
        styles={{
          placeholder: {
            backgroundColor: USER_COLORS[userIndex % USER_COLORS.length],
          },
        }}
      >
        <Text c={theme.white} fz="sm" fw={fontWeight.regular}>
          {user.firstName[0]}
          {user.lastName[0]}
        </Text>
      </Avatar>
    ),
    "Nom Complet": formatFullName(user),
    Fonction: "Chiffreur",
    Email: user.email,
  };

  return tableElement;
};

const USER_COLORS = ["#4675F5", "#C0882F", "#CB3A8D", "#3D88AE", "#419056", "#C83E2E", "#703CE5"];
